import { Theme } from '@mui/material';

export const browseActivitiesByPeriodsStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		gap: '64px',
		pt: { xs: '60px', md: '100px', lg: '80px' },
		pb: { xs: '30px', md: '50px', lg: '80px' },
		px: { xs: '30px', lg: '60px' },
	},
	title: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '20px', md: '30px', lg: '40px' },
		fontStyle: 'italic',
		fontWeight: 400,
		textTransform: 'uppercase',
		textAlign: 'center',
	},
});
